<app-dialog-container>
  <div fxFlex="column" class="dialog-content">
    <mat-card-title>O que deseja ver por aqui?</mat-card-title>
    <form [formGroup]="form">
      <app-input
        *ngIf="getFieldConfig('description')"
        [config]="getFieldConfig('description')"
        [group]="form">
      </app-input>
      
      <!-- Campo de Tipo de Evento utilizando o componente de select -->
      <app-select
        *ngIf="getFieldConfig('typeEvent')"
        [config]="getFieldConfig('typeEvent')"
        [group]="form">
      </app-select>
      
      <!-- Campo de Tipo de Formulário utilizando o componente de select -->
      <app-select
        *ngIf="getFieldConfig('typeQuestion')"
        [config]="getFieldConfig('typeQuestion')"
        [group]="form">
      </app-select>
    </form>
  </div>
</app-dialog-container>
